import { render, staticRenderFns } from "./OwnedProcesses.vue?vue&type=template&id=2a9639fa&scoped=true&"
import script from "./OwnedProcesses.vue?vue&type=script&lang=js&"
export * from "./OwnedProcesses.vue?vue&type=script&lang=js&"
import style0 from "./OwnedProcesses.vue?vue&type=style&index=0&id=2a9639fa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a9639fa",
  null
  
)

export default component.exports